import axios from 'axios';
import { openRatingModal } from './caller-components/ratingModalStore';
import { clearTokens, failureEndsSignIn, refreshAccessToken } from './utils/tokenStore';

// K4 Aşama 3 (owner, 2026-10-13): the tokens live in memory
// (utils/tokenStore.js), not in localStorage. On a 401 the request is retried
// once with a new access token from tokenStore.refreshAccessToken(), which is
// single-flight (concurrent 401s share one refresh) and falls back to the
// browser's Django session for this tab's own account. tokenStore makes its
// own calls with fetch, so they never pass through this interceptor; the URL
// check below only keeps any axios caller of those endpoints from being
// retried. When no token can be had, the tab goes to the sign-in page; the
// storage the tabs share is cleared only when the server is done with this
// browser's sign-in (see leaveToLogin).

const NO_RETRY_URLS = ['/api2/v2/auth/login/', '/kimlik/v1/token/', '/api2/v2/login/refresh/'];

const isTokenCall = (config) => {
  const url = (config && config.url) || '';
  return NO_RETRY_URLS.some((tokenUrl) => url.indexOf(tokenUrl) !== -1);
};

// K4 Aşama 3 (owner, 2026-10-13): localStorage.clear() is a browser-wide
// sign-out now (every tab following its account leaves on it), so it runs
// only when the refresh failed because the server refused this browser
// (tokenStore.failureEndsSignIn). A network blip, a 429 or a 5xx only sends
// this tab to the sign-in page, whose load asks the session again. A
// share-link tab (new/viewer2) runs on the token in its URL, not on this
// browser's sign-in, so its failures never clear the shared storage either.
const isShareLinkPage = () => window.location.href.includes('new/viewer2');

const leaveToLogin = (refreshError) => {
  clearTokens();
  if (!isShareLinkPage() && failureEndsSignIn(refreshError)) {
    window.localStorage.clear();
  }
  window.location.href = "/new/login";
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && originalRequest && !originalRequest._retry && !isTokenCall(originalRequest)) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshAccessToken();

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;
        originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;

        return axios(originalRequest);

      } catch (refreshError) {
        leaveToLogin(refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// ---------------------------------------------------------------------------
// Hekim Analiz Puanlama Modalı — başarılı onay/revizyon cevaplarını izler.
// Backend cevabında show_rating_modal === true varsa, URL'den analysis_pk'yi
// çıkarır ve global RatingModal'ı açar. Koşullar backend'de hesaplanır;
// frontend tekrar değerlendirmez. Tek modal instance -> aynı cevap iki kez
// işlense de yalnızca bir kere açılır; sayfa yenilendiğinde açılmaz.
// ---------------------------------------------------------------------------
const RATING_TRIGGER_PATTERN =
  /\/api2\/v2\/(analysisonay|showanalysisonay|analysisrevision|showanalysisrevision)\/(\d+)\//;

axios.interceptors.response.use((response) => {
  try {
    const url = response?.config?.url || '';
    if (RATING_TRIGGER_PATTERN.test(url) && response?.data?.show_rating_modal) {
      const match = url.match(RATING_TRIGGER_PATTERN);
      const analysisPk = match ? match[2] : null;
      const reasons = (response?.data?.rating_modal_reasons) || [];
      if (analysisPk) {
        openRatingModal(analysisPk, reasons);
      }
    }
  } catch (e) {
    // puanlama modalı tetiklemesi asla ana akışı bozmamalı
  }
  return response;
});

export default axios;
